import { render, staticRenderFns } from "./AnalyticsStock.vue?vue&type=template&id=25280697&scoped=true"
import script from "./AnalyticsStock.vue?vue&type=script&lang=js"
export * from "./AnalyticsStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25280697",
  null
  
)

export default component.exports